import React, { useState, useEffect } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Scroll Effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll); // cleanup
  }, []);

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="nav-wrapper">
        
        {/* Logo */}
        <div className="logo-area">
          <img 
            src="/img/web_logo.png" 
            alt="NewLife Research" 
            className="logo-img" 
          />
        </div>

        {/* Desktop Menu */}
        <nav className="nav-links">
          <a href="#home">Home</a>
          <a href="#products">Products</a>
          <a href="#ingredients">Research</a>
          <a href="#about">About Us</a>
          
        </nav>
          <a href="#contact" className="nav-btn">Contact</a>

        {/* Mobile Menu Button */}
        <button className={`menu-btn ${open ? "active" : ""}`} onClick={() => setOpen(!open)}>
          <span className="menu-icon">☰</span>
        </button>
      </div>

      {/* Mobile Dropdown */}
      <div className={`mobile-menu ${open ? "active" : ""}`}>
       <a href="#home">Home</a>
          <a href="#products">Products</a>
          <a href="#ingredients">Research</a>
          <a href="#about">About Us</a>
        {/* <a href="#" className="mobile-btn">Contact</a> */}
      </div>
    </header>
  );
};

export default Navbar;
